import getUpscCurrentAffairsSeoInitialProps from './upscCurrentAffairsSeoCache';

const getUpscCurrentAffairsPageSeoProps = (seoPageKey) => async (ctx) => {
  const seoInitialProps = await getUpscCurrentAffairsSeoInitialProps();
  const canonicalPath = (ctx.asPath || ctx.pathname || '')
    .split('?')[0]
    .split('#')[0];

  return {
    upscPageSeo: seoInitialProps.upscSeoConfig?.[seoPageKey] ?? null,
    canonicalPath
  };
};

export default getUpscCurrentAffairsPageSeoProps;
